import { Injectable } from '@angular/core';
import {
	VehicleRoadTaxListDto,
	VehicleRoadTaxRecordDto,
	VehicleRoadTaxesAppOptionsDto,
	VehicleRoadTaxesFilters,
	VehicleRoadTaxesStatsDto,
	VehicleRoadTaxSearchDto,
	CreateVehicleRoadTaxDto,
	UpdateVehicleRoadTaxDto,
} from '@splitsecondconnect/ultramarine-shared';

import { BaseRecordResolver } from '../../../../shared/base-classes/base-record.resolver';
import { VehicleRoadTaxesService } from '../vehicle-road-taxes.service';

@Injectable({
	providedIn: 'root',
})
export class VehicleRoadTaxesRecordResolver extends BaseRecordResolver<
	VehicleRoadTaxRecordDto,
	CreateVehicleRoadTaxDto,
	UpdateVehicleRoadTaxDto,
	VehicleRoadTaxListDto,
	VehicleRoadTaxesStatsDto,
	VehicleRoadTaxesAppOptionsDto,
	VehicleRoadTaxesFilters,
	VehicleRoadTaxSearchDto
> {
	constructor(private _vehicleRoadTaxesService: VehicleRoadTaxesService) {
		super(_vehicleRoadTaxesService);
	}
}
